export const PLANS = [
  {
    id: "launch",
    name: "Launch",
    price: "₹10,499",
    original: null,
    savings: "Save ₹20,000 p.a.",
    maintenance: null,
    badge: null,
    highlighted: false,
    cta: "Contact sales",
    features: [
      "Professional Websites",
      "SEO",
      "Secure checkout",
      "Deliveries",
      "Tracking",
    ],
  },
  {
    id: "grow",
    name: "Grow",
    price: "₹28,499",
    original: "₹30,499",
    savings: "Save ₹50,000 p.a.",
    maintenance: null,
    badge: null,
    highlighted: false,
    cta: "Contact sales",
    features: [
      "Professional Websites",
      "App dev",
      "SEO",
      "E-commerce",
      "Secure checkout",
      "Custom animations",
      "Tracking",
      "Digital ads",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "₹48,499",
    original: "₹53,499",
    savings: "Save ₹70,000 p.a.",
    maintenance: "100% off on maintenance for 1 year",
    badge: null,
    highlighted: false,
    cta: "Contact sales",
    features: [
      "Professional Websites",
      "App dev",
      "SEO",
      "E-commerce",
      "Secure checkout",
      "Custom animations",
      "Multilingual",
      "Tracking",
      "Digital ads",
      "Ivory template prints",
      "Ad boosts",
      "Posters",
    ],
  },
  {
    id: "plus",
    name: "Plus",
    price: "₹61,499",
    original: "₹66,499",
    savings: "Save ₹1,00,000 p.a.",
    maintenance: "100% off on maintenance for 1 year",
    badge: "MOST POPULAR",
    highlighted: true,
    cta: "Contact sales",
    features: [
      "Professional Websites",
      "App dev",
      "SEO",
      "E-commerce",
      "Secure checkout",
      "Custom animations",
      "Multilingual",
      "Tracking",
      "Digital ads",
      "Ivory template prints",
      "Ad boosts",
      "Posters",
      "Deliveries",
      "T-shirts",
      "Helmet",
      "Bag",
    ],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Let's talk",
    original: null,
    savings: "Save ₹1,50,000 p.a.",
    maintenance: null,
    badge: "CUSTOM SCALE",
    highlighted: false,
    cta: "Contact team",
    features: [
      "Professional Websites",
      "App dev",
      "SEO",
      "E-commerce",
      "Secure checkout",
      "Custom animations",
      "Multilingual",
      "Tracking",
      "Digital ads",
      "Ivory template prints",
      "Ad boosts",
      "Posters",
      "Deliveries",
      "T-shirts",
      "Helmet",
      "Bag",
      "Seasonal redesigns",
      "Franchise optimization",
    ],
  },
];

export const ALL_FEATURES = [
  "Professional Websites",
  "App dev",
  "SEO",
  "E-commerce",
  "Secure checkout",
  "Custom animations",
  "Multilingual",
  "Tracking",
  "Digital ads",
  "Ivory template prints",
  "Ad boosts",
  "Posters",
  "Deliveries",
  "T-shirts",
  "Helmet",
  "Bag",
  "Seasonal redesigns",
  "Franchise optimization",
];

export const PLAN_OPTIONS = ["Launch", "Grow", "Pro", "Plus", "Enterprise", "General Inquiry"];
